import { IDigitalPropertyType } from '../interfaces/digital-property.interface';
import { $digitalPropertyType, MOBILE_DIGITAL_PROPERTY_TYPE_NAMES } from '../constants/digital-properties';

export class DigitalPropertyTypeUtility {
  public static isWebsite(type: IDigitalPropertyType): boolean {
    return type?.canRestrictDomain;
  }

  public static isMobile(type: IDigitalPropertyType): boolean {
    return MOBILE_DIGITAL_PROPERTY_TYPE_NAMES.includes(type[$digitalPropertyType.name]);
  }
}
